"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.custom_config = void 0;
exports.custom_config = {
    "modules": {
        "sh_a_cp_desc": {
            "defaults": true,
            "title": "沪A涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#sh_a_board",
            "tabletype": "ABChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "m:1+t:2,m:1+t:23"
        },
        "sh_a_5mincp_desc": {
            "defaults": true,
            "title": "沪5分钟涨幅",
            "link": "/gridlist.html?st=FiveMinuteChangePercent&sr=-1#sh_a_board",
            "tabletype": "AB5MinChangePercent",
            "count": 5,
            "order": "f11",
            "orderdur": false,
            "fs": "m:1+t:2,m:1+t:23"
        },
        "sh_a_cp_asc": {
            "defaults": true,
            "title": "沪A跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#sh_a_board",
            "tabletype": "ABChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "m:1+t:2,m:1+t:23"
        },
        "sh_a_5mincp_asc": {
            "defaults": true,
            "title": "沪5分钟跌幅",
            "link": "/gridlist.html?st=FiveMinuteChangePercent&sr=1#sh_a_board",
            "tabletype": "AB5MinChangePercent",
            "count": 5,
            "order": "f11",
            "orderdur": true,
            "fs": "m:1+t:2,m:1+t:23"
        },
        "sz_a_cp_desc": {
            "defaults": true,
            "title": "深A涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#sz_a_board",
            "tabletype": "ABChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80"
        },
        "sz_a_5mincp_desc": {
            "defaults": true,
            "title": "深5分钟涨幅",
            "link": "/gridlist.html?st=FiveMinuteChangePercent&sr=-1#sz_a_board",
            "tabletype": "AB5MinChangePercent",
            "count": 5,
            "order": "f11",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80"
        },
        "sz_a_cp_asc": {
            "title": "深A跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#sz_a_board",
            "tabletype": "ABChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "m:0+t:6,m:0+t:80"
        },
        "sz_a_5mincp_asc": {
            "title": "深5分钟跌幅",
            "link": "/gridlist.html?st=FiveMinuteChangePercent&sr=1#sz_a_board",
            "tabletype": "AB5MinChangePercent",
            "count": 5,
            "order": "f11",
            "orderdur": true,
            "fs": "m:0+t:6,m:0+t:80"
        },
        "hs_a_turnoverrate": {
            "title": "换手率",
            "link": "/gridlist.html?st=TurnoverRate&sr=-1#hs_a_board",
            "tabletype": "ABTurnoverRate",
            "count": 5,
            "order": "f8",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "hs_a_volumerate": {
            "title": "量比",
            "link": "/gridlist.html?st=VolumeRate&sr=-1#hs_a_board",
            "tabletype": "ABVolumeRate",
            "count": 5,
            "order": "f10",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "hs_a_amplitude": {
            "title": "振幅",
            "link": "/gridlist.html?st=Amplitude&sr=-1#hs_a_board",
            "tabletype": "ABAmplitude",
            "count": 5,
            "order": "f7",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "hs_a_amount": {
            "title": "成交额",
            "link": "/gridlist.html?st=Amount&sr=-1#hs_a_board",
            "tabletype": "ABAmount",
            "count": 5,
            "order": "f6",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "hs_a_pe": {
            "title": "市盈率",
            "link": "/gridlist.html?st=PERation&sr=1#hs_a_board",
            "tabletype": "ABPE",
            "count": 5,
            "order": "f9",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "hs_a_pb": {
            "title": "市净率",
            "link": "/gridlist.html?st=PB&sr=1#hs_a_board",
            "tabletype": "ABPB",
            "count": 5,
            "order": "f23",
            "orderdur": true,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "hs_a_fcv": {
            "title": "流通市值",
            "link": "/gridlist.html?st=FlowCapitalValue&sr=-1#hs_a_board",
            "tabletype": "ABFlowCapitalValue",
            "count": 5,
            "order": "f21",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "hs_a_mv": {
            "title": "总市值",
            "link": "/gridlist.html?st=MarketValue&sr=-1#hs_a_board",
            "tabletype": "ABMarketValue",
            "count": 5,
            "order": "f20",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "hs_a_60dcp_desc": {
            "title": "60日涨幅",
            "link": "/gridlist.html?st=ChangePercent60Day&sr=-1#hs_a_board",
            "tabletype": "AB60DayChangePercent",
            "count": 5,
            "order": "f24",
            "orderdur": false,
            "fs": "m:0+t:6+f:!2,m:0+t:80+f:!2,m:1+t:2+f:!2"
        },
        "hs_a_60dcp_asc": {
            "title": "60日跌幅",
            "link": "/gridlist.html?st=ChangePercent60Day&sr=1#hs_a_board",
            "tabletype": "AB60DayChangePercent",
            "count": 5,
            "order": "f24",
            "orderdur": true,
            "fs": "m:0+t:6+f:!2,m:0+t:80+f:!2,m:1+t:2+f:!2"
        },
        "hs_a_360dcp_desc": {
            "title": "年初至今涨幅",
            "link": "/gridlist.html?st=ChangePercent360Day&sr=-1#hs_a_board",
            "tabletype": "AB360DayChangePercent",
            "count": 5,
            "order": "f25",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "hs_a_360dcp_asc": {
            "title": "年初至今跌幅",
            "link": "/gridlist.html?st=ChangePercent360Day&sr=1#hs_a_board",
            "tabletype": "AB360DayChangePercent",
            "count": 5,
            "order": "f25",
            "orderdur": true,
            "fs": "m:0+t:6+f:!2,m:0+t:80+f:!2,m:1+t:2+f:!2"
        },
        "hs_a_speed": {
            "title": "涨速",
            "link": "/gridlist.html?st=Speed&sr=-1#hs_a_board",
            "tabletype": "ABSpeed",
            "count": 5,
            "order": "f22",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "bj_a_cp_desc": {
            "title": "京A涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#bj_a_board",
            "tabletype": "ABChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "m:0+t:81+s:262144"
        },
        "bj_a_5mincp_desc": {
            "defaults": true,
            "title": "京5分钟涨幅",
            "link": "/gridlist.html?st=FiveMinuteChangePercent&sr=-1#bj_a_board",
            "tabletype": "AB5MinChangePercent",
            "count": 5,
            "order": "f11",
            "orderdur": false,
            "fs": "m:0+t:81+s:262144"
        },
        "bj_a_cp_asc": {
            "title": "京A跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#bj_a_board",
            "tabletype": "ABChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "m:0+t:81+s:262144"
        },
        "bj_a_5mincp_asc": {
            "defaults": true,
            "title": "京5分钟跌幅",
            "link": "/gridlist.html?st=FiveMinuteChangePercent&sr=1#bj_a_board",
            "tabletype": "AB5MinChangePercent",
            "count": 5,
            "order": "f11",
            "orderdur": true,
            "fs": "m:0+t:81+s:262144"
        },
        "industry_cp_desc": {
            "title": "行业涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#industry_board_2",
            "tabletype": "BoardsCPDesc",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "m:90+s:4"
        },
        "industry_cp_asc": {
            "title": "行业跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#industry_board_2",
            "tabletype": "BoardsCPAsc",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "m:90+s:4"
        },
        "region_cp_desc": {
            "title": "地域涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#region_board",
            "tabletype": "BoardsCPDesc",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "m:90+t:1"
        },
        "region_cp_asc": {
            "title": "地域跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#region_board",
            "tabletype": "BoardsCPAsc",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "m:90+t:1"
        },
        "concept_cp_desc": {
            "title": "概念涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#concept_board",
            "tabletype": "BoardsCPDesc",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "m:90+t:3"
        },
        "concept_cp_asc": {
            "title": "概念跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#concept_board",
            "tabletype": "BoardsCPAsc",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "m:90+t:3"
        },
        "industry_position": {
            "title": "行业板块增仓",
            "tabletype": "BoardsPosition",
            "count": 6,
            "order": "f184",
            "orderdur": false,
            "fs": "m:90+s:4"
        },
        "concept_position": {
            "title": "概念板块增仓",
            "tabletype": "BoardsPosition",
            "count": 6,
            "order": "f184",
            "orderdur": false,
            "fs": "m:90+t:3"
        },
        "mainforce_rank": {
            "title": "主力排名",
            "link": "//data.eastmoney.com/zjlx/list.html",
            "tabletype": "FFRanking",
            "count": 5,
            "order": "f184",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "industry_turnoverrate": {
            "title": "行业板块换手率",
            "link": "/gridlist.html?st=TurnoverRate&sr=-1#industry_board",
            "tabletype": "BoardsTurnoverRate",
            "count": 5,
            "order": "f8",
            "orderdur": false,
            "fs": "m:90+s:4"
        },
        "region_turnoverrate": {
            "title": "地域板块换手率",
            "link": "/gridlist.html?st=TurnoverRate&sr=-1#region_board",
            "tabletype": "BoardsTurnoverRate",
            "count": 5,
            "order": "f8",
            "orderdur": false,
            "fs": "m:90+t:1"
        },
        "concept_turnoverrate": {
            "title": "概念板块换手率",
            "link": "/gridlist.html?st=TurnoverRate&sr=-1#concept_board",
            "tabletype": "BoardsTurnoverRate",
            "count": 5,
            "order": "f8",
            "orderdur": false,
            "fs": "m:90+t:3"
        },
        "industry_speed": {
            "title": "行业板块涨速",
            "tabletype": "BoardsSpeed",
            "count": 6,
            "order": "f22",
            "orderdur": false,
            "fs": "m:90+s:4"
        },
        "region_speed": {
            "title": "地域板块涨速",
            "tabletype": "BoardsSpeed",
            "count": 6,
            "order": "f22",
            "orderdur": false,
            "fs": "m:90+t:1"
        },
        "concept_speed": {
            "title": "概念板块涨速",
            "tabletype": "BoardsSpeed",
            "count": 6,
            "order": "f22",
            "orderdur": false,
            "fs": "m:90+t:3"
        },
        "industry_amount": {
            "title": "行业板块成交额",
            "tabletype": "BoardsAmount",
            "count": 6,
            "order": "f6",
            "orderdur": false,
            "fs": "m:90+s:4"
        },
        "region_amount": {
            "title": "地域板块成交额",
            "tabletype": "BoardsAmount",
            "count": 6,
            "order": "f6",
            "orderdur": false,
            "fs": "m:90+t:1"
        },
        "concept_amount": {
            "title": "概念板块成交额",
            "tabletype": "BoardsAmount",
            "count": 6,
            "order": "f6",
            "orderdur": false,
            "fs": "m:90+t:3"
        },
        "mainstocks_captialflow": {
            "title": "大盘资金流向",
            "link": "https://data.eastmoney.com/zjlx/dpzjlx.html",
            "tabletype": "MainCaptialFlow",
            "count": 5,
            "order": "f62",
            "orderdur": true,
            "fs": "m:1+t:1,m:0+t:5"
        },
        "stocks_captialflowin": {
            "title": "个股资金流入",
            "link": "//data.eastmoney.com/zjlx/detail.html",
            "tabletype": "MainCaptialFlow",
            "count": 5,
            "order": "f62",
            "orderdur": false,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "stocks_captialflowout": {
            "title": "个股资金流出",
            "link": "//data.eastmoney.com/zjlx/detail.html",
            "tabletype": "MainCaptialFlow",
            "count": 5,
            "order": "f62",
            "orderdur": true,
            "fs": "m:0+t:6,m:0+t:80,m:1+t:2"
        },
        "industry_captialflow": {
            "title": "行业资金流",
            "link": "//data.eastmoney.com/bkzj/hy.html",
            "tabletype": "BoardsCaptialFlow",
            "count": 5,
            "order": "f62",
            "orderdur": false,
            "fs": "m:90+s:4"
        },
        "region_captialflow": {
            "title": "地域资金流",
            "link": "//data.eastmoney.com/bkzj/dy.html",
            "tabletype": "BoardsCaptialFlow",
            "count": 5,
            "order": "f62",
            "orderdur": false,
            "fs": "m:90+t:1"
        },
        "concept_captialflow": {
            "title": "概念资金流",
            "link": "//data.eastmoney.com/bkzj/gn.html",
            "tabletype": "BoardsCaptialFlow",
            "count": 5,
            "order": "f62",
            "orderdur": false,
            "fs": "m:90+t:3"
        },
        "hkstocks_cp_desc": {
            "title": "全部港股涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#hk_stocks",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "m:116"
        },
        "hkstocks_cp_asc": {
            "title": "全部港股跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#hk_stocks",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "m:116"
        },
        "hkstocks_volume": {
            "title": "全部港股成交量",
            "link": "/gridlist.html?st=Volume&sr=-1#hk_stocks",
            "tabletype": "CommonVolume",
            "count": 5,
            "order": "f5",
            "orderdur": false,
            "fs": "m:116"
        },
        "hkstocks_amount": {
            "title": "全部港股成交额",
            "link": "/gridlist.html?st=Amount&sr=-1#hk_stocks",
            "tabletype": "CommonAmount",
            "count": 5,
            "order": "f6",
            "orderdur": false,
            "fs": "m:116"
        },
        "hk_sh_cp_desc": {
            "title": "港股通(沪)涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#hk_sh_stocks",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0144"
        },
        "hk_sh_cp_asc": {
            "title": "港股通(沪)跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#hk_sh_stocks",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0144"
        },
        "hk_sz_cp_desc": {
            "title": "港股通(深)涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#hk_sz_stocks",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0146"
        },
        "hk_sz_cp_asc": {
            "title": "港股通(深)跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#hk_sz_stocks",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0146"
        },
        "hk_sh_volume": {
            "title": "港股通(沪)成交量",
            "link": "/gridlist.html?st=Volume&sr=-1#hk_sh_stocks",
            "tabletype": "CommonVolume",
            "count": 5,
            "order": "f5",
            "orderdur": false,
            "fs": "b:MK0144"
        },
        "hk_sz_volume": {
            "title": "港股通(深)成交量",
            "link": "/gridlist.html?st=Volume&sr=-1#hk_sz_stocks",
            "tabletype": "CommonVolume",
            "count": 5,
            "order": "f5",
            "orderdur": false,
            "fs": "b:MK0146"
        },
        "hk_sh_amount": {
            "title": "港股通(沪)成交额",
            "link": "/gridlist.html?st=Amount&sr=-1#hk_sh_stocks",
            "tabletype": "CommonAmount",
            "count": 5,
            "order": "f6",
            "orderdur": false,
            "fs": "b:MK0144"
        },
        "hk_sz_amount": {
            "title": "港股通(深)成交额",
            "link": "/gridlist.html?st=Amount&sr=-1#hk_sz_stocks",
            "tabletype": "CommonAmount",
            "count": 5,
            "order": "f6",
            "orderdur": false,
            "fs": "b:MK0146"
        },
        "hk_redchips_cp_desc": {
            "title": "红筹股涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#hk_redchips",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0102"
        },
        "hk_redchips_cp_asc": {
            "title": "红筹股跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#hk_redchips",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0102"
        },
        "hk_bluechips_cp_desc": {
            "title": "蓝筹股涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#hk_bluechips",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0105"
        },
        "hk_bluechips_cp_asc": {
            "title": "蓝筹股跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#hk_bluechips",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0105"
        },
        "hk_stateowned_cp_desc": {
            "title": "国企股涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#hk_stateowned",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0103"
        },
        "hk_stateowned_cp_asc": {
            "title": "国企股跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#hk_stateowned",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0103"
        },
        "hk_gem_cp_desc": {
            "title": "创业板涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#hk_gem",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "m:116+t:4"
        },
        "hk_gem_cp_asc": {
            "title": "创业板跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#hk_gem",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "m:116+t:4"
        },
        "us_cp_desc": {
            "title": "全部美股涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#us_stocks",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "m:105,m:106,m:107"
        },
        "us_cp_asc": {
            "title": "全部美股跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#us_stocks",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "m:105,m:106,m:107"
        },
        "us_wellknown_desc": {
            "title": "知名美股涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#us_wellknown",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0001"
        },
        "us_wellknown_asc": {
            "title": "知名美股跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#us_wellknown",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0001"
        },
        "us_chinese_desc": {
            "title": "中概股涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#us_chinese",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0201"
        },
        "us_chinese_asc": {
            "title": "中概股跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#us_chinese",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0201"
        },
        "us_chinese_internet_desc": {
            "title": "互联网中国涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#us_chinese_internet",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0202"
        },
        "us_chinese_internet_asc": {
            "title": "互联网中国跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#us_chinese_internet",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0202"
        },
        "us_technology_desc": {
            "title": "科技类涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#us_technology",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0216"
        },
        "us_technology_asc": {
            "title": "科技类跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#us_technology",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0216"
        },
        "us_financial_desc": {
            "title": "金融类涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#us_financial",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0217"
        },
        "us_financial_asc": {
            "title": "金融类跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#us_financial",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0217"
        },
        "us_medicine_food_desc": {
            "title": "医药食品类涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#us_medicine_food",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0218"
        },
        "us_medicine_food_asc": {
            "title": "医药食品类跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#us_medicine_food",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0218"
        },
        "us_media_desc": {
            "title": "媒体类涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#us_media",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0220"
        },
        "us_media_asc": {
            "title": "媒体类跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#us_media",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0220"
        },
        "us_automotive_energy_desc": {
            "title": "汽车能源类涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#us_automotive_energy",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0219"
        },
        "us_automotive_energy_asc": {
            "title": "汽车能源类跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#us_automotive_energy",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0219"
        },
        "us_manufacture_retail_desc": {
            "title": "制造零售类涨幅",
            "link": "/gridlist.html?st=ChangePercent&sr=-1#us_manufacture_retail",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": false,
            "fs": "b:MK0221"
        },
        "us_manufacture_retail_asc": {
            "title": "制造零售类跌幅",
            "link": "/gridlist.html?st=ChangePercent&sr=1#us_manufacture_retail",
            "tabletype": "CommonChangePercent",
            "count": 5,
            "order": "f3",
            "orderdur": true,
            "fs": "b:MK0221"
        }
    },
    "groups": [
        {
            "title": "沪深京A股",
            "next": [
                {
                    "title": "个股排行",
                    "next": [
                        "sh_a_cp_desc",
                        "sh_a_5mincp_desc",
                        "sh_a_cp_asc",
                        "sh_a_5mincp_asc",
                        "sz_a_cp_desc",
                        "sz_a_5mincp_desc",
                        "sz_a_cp_asc",
                        "sz_a_5mincp_asc",
                        "bj_a_cp_desc",
                        "bj_a_5mincp_desc",
                        "bj_a_cp_asc",
                        "bj_a_5mincp_asc",
                        "hs_a_turnoverrate",
                        "hs_a_volumerate",
                        "hs_a_amplitude",
                        "hs_a_amount",
                        "hs_a_pe",
                        "hs_a_pb",
                        "hs_a_fcv",
                        "hs_a_mv",
                        "hs_a_60dcp_desc",
                        "hs_a_60dcp_asc",
                        "hs_a_360dcp_desc",
                        "hs_a_360dcp_asc",
                        "hs_a_speed"
                    ]
                },
                {
                    "title": "板块排行",
                    "next": [
                        "industry_cp_desc",
                        "industry_cp_asc",
                        "region_cp_desc",
                        "region_cp_asc",
                        "concept_cp_desc",
                        "concept_cp_asc",
                        "industry_position",
                        "concept_position",
                        "industry_turnoverrate",
                        "region_turnoverrate",
                        "concept_turnoverrate",
                        "industry_speed",
                        "region_speed",
                        "concept_speed",
                        "industry_amount",
                        "region_amount",
                        "concept_amount"
                    ]
                },
                {
                    "title": "特色数据",
                    "next": [
                        "mainstocks_captialflow",
                        "stocks_captialflowin",
                        "stocks_captialflowout",
                        "mainforce_rank",
                        "industry_captialflow",
                        "region_captialflow",
                        "concept_captialflow"
                    ]
                }
            ]
        },
        {
            "title": "港股美股",
            "next": [
                {
                    "title": "港股市场",
                    "next": [
                        "hkstocks_cp_desc",
                        "hkstocks_cp_asc",
                        "hkstocks_volume",
                        "hkstocks_amount",
                        "hk_sh_cp_desc",
                        "hk_sh_cp_asc",
                        "hk_sz_cp_desc",
                        "hk_sz_cp_asc",
                        "hk_sh_volume",
                        "hk_sz_volume",
                        "hk_sh_amount",
                        "hk_sz_amount",
                        "hk_redchips_cp_desc",
                        "hk_redchips_cp_asc",
                        "hk_bluechips_cp_desc",
                        "hk_bluechips_cp_asc",
                        "hk_stateowned_cp_desc",
                        "hk_stateowned_cp_asc",
                        "hk_gem_cp_desc",
                        "hk_gem_cp_asc"
                    ]
                },
                {
                    "title": "美股市场",
                    "next": [
                        "us_cp_desc",
                        "us_cp_asc",
                        "us_wellknown_desc",
                        "us_wellknown_asc",
                        "us_chinese_desc",
                        "us_chinese_asc",
                        "us_chinese_internet_desc",
                        "us_chinese_internet_asc",
                        "us_technology_desc",
                        "us_technology_asc",
                        "us_financial_desc",
                        "us_financial_asc",
                        "us_medicine_food_desc",
                        "us_medicine_food_asc",
                        "us_media_desc",
                        "us_media_asc",
                        "us_automotive_energy_desc",
                        "us_automotive_energy_asc",
                        "us_manufacture_retail_desc",
                        "us_manufacture_retail_asc"
                    ]
                }
            ]
        }
    ]
};
